<template>
  <div id="joinDetails">
    <div class="container">
      <div class="container-t">
        <div class="container-in">
          <span class="container-title">视觉算法资深工程师</span>
          <span class="container-money">30K-50K</span>
        </div>
        <div class="container-button">
          <el-button class="el-button" size="mini" round>加班补助</el-button>
          <el-button class="el-button" size="mini" round>带薪年假</el-button>
        </div>
      </div>
      <div class="container-text">
        <div class="timeAndYear">
          <p>发布时间：2021-08-01</p>
          <p style="margin-top: 16px;">工作年限：1-3年</p>
        </div>
        <div class="workplaceAndEducation">
          <p>工作地点：北京</p>
          <p style="margin-top: 16px;">学历：不限</p>
        </div>
        <div class="upload">
          <a class="tab-programme-a" href="javascript:;" @click="routerNewsMore">上传简历</a>
        </div>
      </div>
      <div class="line"></div>
      <div class="duty">
        <p class="duty-title">工作职责</p>
        <div class="duty-text">
          <p>1. 人脸识别、证卡OCR、车辆结构化、视频分析等相关方向前沿算法的设计、优化和实现；</p>
          <p> 2. 算法模型生产全流程包括数据生产、模型设计、训练、适配和调优，且识别产品的瓶颈并提出解决方案；</p>
          <p> 3. 模型在不同的移动平台上进行移植适配，性能优化。</p>
        </div>
        <div class="line"></div>
      </div>
      <div class="duty">
        <p class="duty-title">工作要求</p>
        <div class="duty-text">
          <p>1. 机器学习，深度学习，计算机视觉等领域，硕士以上学历；</p>
          <p>2. 熟悉至少一种深度学习框架(TensorFlow/Caffe/MXNet/PyTorch/Keras等)；</p>
          <p>3. 具备丰富的模型调参经验，对深度学习网络结构理解深刻；</p>
          <p>4. 熟悉深度学习的检测、识别、分割、跟踪、检索等，有实际项目经验；</p>
          <p>5. 或熟悉深度学习模型优化和加速算法，有实际项目经验；</p>
          <p>6. 或熟悉深度神经网络底层计算实现，了解量化等计算优化方法；</p>
        </div>
      </div>
      <!--上传简历弹框-->
      <el-dialog title="上传简历" :visible.sync="dialogVisible" width="30%"
        :close-on-click-modal="false" :close-on-press-escape="false">
        <template v-if="!file">
          <div class="dialog">
            <p style="margin-bottom: 12px;">支持DOC.DOCX、PDF、JPG格式简历文件</p>
            <p style="margin-bottom: 56px;">文件大小不得大于10M</p>
          </div>
        </template>
        <template v-else>
          <div class="dialog">
            <div class="success">
              <p>
                <span class="key">附件名称：</span>
                <span class="value">{{file.name}}</span>
              </p>
              <p style="margin:12px 0 12px 0">
                <span class="key">附件大小：</span>
                <span class="value">{{file.size}}</span>
              </p>
              <p style="margin-bottom: 56px">
                <span class="key">附件格式：</span>
                <span class="value">{{file.fileFormat}}</span>
              </p>
              <p style="font-size: 14px;color: #FD6622;margin-bottom: 56px;" v-if="visible">
                文件大小不得大于10M请重新上传</p>
            </div>
          </div>
        </template>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" onclick="f.click()" size="small">上传简历</el-button>
          <input type="file" id="f" @change="fileChange($event)" hidden
            accept=".doc,.docx,.pdf,.jpg" />
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "JoinDetails",
  data () {
    return {
      dialogVisible: false,
      visible: false,
      file: null
    }
  },
  methods: {
    routerNewsMore () {
      this.dialogVisible = true
    },
    // 文件上传
    fileChange (e) {
      let nowFile = e.target.files[0]
      console.log(nowFile)
      if (!nowFile) return
      this.file = {
        size: (nowFile.size / 1024 / 1024).toFixed(2) + 'M',
        name: nowFile.name.split('.')[0],
        fileFormat: '.' + nowFile.name.split('.')[1]
      }
      console.log(this.file)
      // console.log(e)
      // let self = this;
      // console.log(self)
      // e.preventDefault();
      // var SuffixName = this.GetExtensionFileName(e.target.value);
      // if (SuffixName != 'jpg' && SuffixName != 'png' && SuffixName != 'jpeg') {
      //   alert({  message: '请上传正确格式的图片',  position: 'bottom',  duration: 3000});
      //   return;
      // }
      // if (this.file.size > 15 * 1024 * 1024) { // 此处判断上传文件的大小 , 单位为 b 故要乘以两个1024
      if (nowFile.size > 15) { // 此处判断上传文件的大小 , 单位为 b 故要乘以两个1024
        // alert('111');
        this.visible = true
        // this.$refs.referenceUpload.value = null;
      }
      // let formData = new FormData();
      // formData.append('prefix', 'createCourseCover');
      // formData.append('file', this.file);

      // this.FetchPost('/media/upload', formData).then(res=> {
      //   if (res.code == 0) {
      //     this.form.cover = res.data;
      //     this.$refs.referenceUpload.value = null;
      //   } else {
      //     alert({  message: res.message,  position: 'bottom',  duration: 3000});
      //   }
      // }).catch(function (error) {
      //   self.loading = false;
      //   console.log(error)
      // });
    },

  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#joinDetails {
  background-color: #f6f8fb;
  padding-top: 40px;
  padding-bottom: 346px;
}
.container {
  width: 1180px;
  margin: auto;
  background-color: #fff;
  padding: 40px;
}
.container-t {
  display: flex;
  justify-content: space-between;
}
.container-title {
  color: #333333;
  font-weight: 500;
  font-size: 24px;
}
.container-money {
  margin-left: 24px;
  color: #77ba00;
  font-weight: 500;
  font-size: 24px;
}
.el-button {
  color: #77ba00;
  border: 1px solid #77ba00;
}
.el-button:hover {
  color: #fff;
  border: 1px solid #77ba00;
  background-color: #77ba00;
}
.container-text {
  margin-top: 40px;
}
.container-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tab-programme-a {
  display: inline-block;
  width: 120px;
  height: 40px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  background: #77ba00;
  text-decoration: none;
  margin-top: 0px;
}
.line {
  width: 1100px;
  height: 1px;
  background: #eaeaea;
  margin-top: 40px;
}
.duty-title {
  margin-top: 39px;
  margin-bottom: 20px;
  color: #333333;
  font-size: 20px;
}
.duty-text p {
  margin-bottom: 5px;
  color: #333333;
  font-size: 16px;
}
.dialog {
  border-top: 1px solid #eeeeee;
  margin-top: 15px;
  padding: 24px 24px 0 24px;
  font-size: 14px;
  color: #666666;
  text-align: center;
}
.success {
  text-align: left;
}
.key {
  color: #666666;
  font-size: 14px;
}
.value {
  color: #333333;
  font-size: 14px;
}
::v-deep .el-dialog__title {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
::v-deep .el-dialog__footer {
  padding: 0 24px 24px 0;
  text-align: center;
}
.el-button {
  border-radius: 0;
}
.el-button--success {
  color: #fff;
  background-color: #77ba00;
  border-color: #77ba00;
}
::v-deep .el-dialog__close:hover {
  color: #77ba00 !important;
}
</style>